import { useEffect, useRef } from 'react'
import { apiFetch } from '../services/api'

/**
 * Records one daily "active" event for the signed-in user on app load.
 * The server dedups to a single row per user per UTC day (partial unique
 * index), so a per-mount guard is all we need here. This is the source of
 * truth for "days active / days logged in" in the admin engagement dashboard.
 */
export function useActivityPing(enabled: boolean) {
  const sent = useRef(false)
  useEffect(() => {
    if (!enabled || sent.current) return
    sent.current = true
    apiFetch('/activity/ping', { method: 'POST' }).catch(() => {
      // allow a retry on a later render if the first attempt failed
      sent.current = false
    })
  }, [enabled])
}
